import ProductionStatDashboard from './ProductionStatDashboard';

import './ProductionManagement.css';

/**
 * /production 페이지 — 표시 전용 (item 5, 2026-05-22).
 * 수주(production.data) 테이블 · 검색 · 생산이력 등록 UI 제거.
 * 수주는 /contract 전용. 생산은 ProductionStatDashboard(통계 + 일자별 생산 로그)만.
 */
const ProductionManagement = () => {
  return (
    <div className="dashboard">
      <ProductionStatDashboard />
    </div>
  );
};

export default ProductionManagement;
